export default class CheckboxFilterBuilder {
  filter: HTMLElement;
  data: Object;
  group: Object;

  /**
   * Create a new CheckboxFilterBuilder
   */
  constructor(template: HTMLElement, data: Object, group: Object) {
    this.filter = template;
    this.data = data;
    this.group = group;
  }

  /**
   * Build the filter its HTML
   */
  build(): HTMLElement {
    const checkboxInput = this.filter.getElementByRef('checkbox');
    const checkboxLabel = this.filter.getElementByRef('label');

    this.filter.setAttribute('data-id', this.data.id);
    this.filter.setAttribute('data-name', this.data.name);
    this.filter.setAttribute('data-group', this.group.id);
    checkboxInput.setAttribute('id', this.data.id);
    checkboxLabel.setAttribute('for', this.data.id);
    checkboxLabel.innerText = this.data.name;

    if (this.data.isActive) {
      checkboxInput.setAttribute('checked', 'true');
    } else {
      checkboxInput.removeAttribute('checked');
    }

    return this.filter;
  }
}
